import UserInfoStep from './UserInfoStep';
import { log } from '@utils/logging';

export const USER_INFO_STEP = 0;

interface StepProps {
    step: number;
}

export default function OnboardingSteps(props: StepProps) {
    let stepContent = null as unknown as JSX.Element;
    const { step } = props;

    switch (step) {
        case USER_INFO_STEP:
            stepContent = <UserInfoStep />;
            break;
        default:
            log(`Invalid SignUp step reached: ${step}`);
            break;
    }

    return stepContent;
}
